import { render, staticRenderFns } from "./Form.input.select.vue?vue&type=template&id=2edba3e4"
import script from "./Form.input.select.vue?vue&type=script&lang=js"
export * from "./Form.input.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports